const axios = require('axios');
const uniqBy = require('lodash.uniqby');
const CountryLanguage = require('country-language');

let httpAgent, httpsAgent;
const getHttpAgents = () => {
  if (httpAgent === undefined) {
    const http = require('http');
    httpAgent = new http.Agent({keepAlive: true});
  }
  if (httpsAgent === undefined) {
    const https = require('https');
    httpsAgent = new https.Agent({keepAlive: true});
  }
  return { httpAgent, httpsAgent };
};

const getDefaultLanguage = (regionCode) => {
  return new Promise((resolve) => {
    if (regionCode) {
      CountryLanguage.getCountryLanguages(regionCode, (err, languages) => {
        if (languages.length > 0) {
          return resolve (languages[0].iso639_1);
        }
        return resolve();
      })
    } else {
      return resolve();
    }
  });
}
const searchYouTubeVideos = async ({ googleApiKey, keywords, regionCode, maxResults, silent = false }) => {
  const relevanceLanguage = await getDefaultLanguage(regionCode);
  // eslint-disable-next-line no-console
  console.log(`relevanceLanguage for region, ${regionCode}: ${relevanceLanguage}`);
  const search = async (keyword) => {
    const { httpAgent, httpsAgent } = getHttpAgents();
    const response = await axios.get('https://www.googleapis.com/youtube/v3/search', {
      httpAgent,
      httpsAgent,
      params: {
        key: googleApiKey,
        maxResults: Math.ceil(maxResults / keywords.length),
        part: 'snippet',
        regionCode: regionCode || undefined, // deal with empty string
        q: keyword,
        order: 'relevance',
        publishedAfter: (new Date(Date.now()-24*60*60000)).toISOString(), // one day agao
        safeSearch: 'moderate',
        type: 'video',
        relevanceLanguage,
      },
    }).catch((err) => {
      if (!silent) {
        // eslint-disable-next-line no-console
        console.error(`search youtube videos failed with credential ${googleApiKey}`, err.response && err.response.data);
        throw err;
      }
      return [];
    });
    return response.data.items.map((item) => {
      const { snippet } = item;
      const id = item.id.videoId;    
      return {
        id,
        title: snippet.title,
        created: snippet.publishedAt,
        thumbnail: snippet.thumbnails.high.url || snippet.thumbnails.default.url,
        url: `https://www.youtube.com/watch?v=${id}`,
      };
    });
  };
  let videoSets = await Promise.all(keywords.map(search));
  const videos = [];
  while (videoSets.length > 0) {
    videoSets = videoSets.map((videoSet) => {
      const video = videoSet.shift();
      if (video) {
        videos.push(video);
      }
      return videoSet;
    });
    videoSets = videoSets.filter(set => set.length > 0);
  }
  return uniqBy(videos, 'id').slice(0, maxResults);
};

module.exports = {
  searchYouTubeVideos,
};
